import React, {useEffect, useState} from 'react';
import {Modal, ModalBody} from 'reactstrap';
import PropTypes from 'prop-types';
import Close from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import styles from './UntrackModal.scss';

const UntrackModal = (props) => {

  const {
    showModal,
    handleCloseModalChange,
    handleUntrackButtonClick,
    isPropertyUntrackModal,
  } = props;

  const [untrackLabel, setUntrackLabel] = useState('');

  useEffect(() => {
    if (isPropertyUntrackModal) {
      setUntrackLabel('property');
    } else {
      setUntrackLabel('suburb');
    }
  }, [isPropertyUntrackModal]);

  return <Modal isOpen={showModal} toggle={handleCloseModalChange} className={styles.modalContainer} zIndex={3000}>
    <ModalBody className={styles.modalBody}>
      <label className={styles.modalBodayTitle}>Are you sure you want to untrack this {untrackLabel}?</label>
      <Close className={styles.closeButton}
        onClick={handleCloseModalChange}/>
      <br />
      <br />
      <p>By untracking this {untrackLabel} you will no longer receive monthly email updates on this {untrackLabel}.</p>
      <div className={styles.buttonContainer}>
        <div className={styles.cancelButton} onClick={handleCloseModalChange}>
          Cancel
        </div>
        <Button
          variant={'contained'}
          color={'primary'}
          onClick={handleUntrackButtonClick}>
          {`Untrack ${untrackLabel}`}
        </Button>
      </div>
    </ModalBody>
  </Modal>;
};

UntrackModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  handleCloseModalChange: PropTypes.func.isRequired,
  handleUntrackButtonClick: PropTypes.func.isRequired,
  isPropertyUntrackModal: PropTypes.bool.isRequired,
};

export default UntrackModal;